/**
 * Calculates how much time element has buffered ahead of its
 * current status in seconds.
 */
export function getPlayableBufferDuration(element: HTMLMediaElement) {
  const startingPoint = element.currentTime;
  const buffered = element.buffered;

  // Get the buffered ranges and find one matching fromTime
  let index = buffered.length;

  while (index--) {
    if (buffered.start(index) <= startingPoint && startingPoint <= buffered.end(index)) {
      break;
    }
  }

  // Calculate how much time is playable from the found range
  let playableTime = 0;

  if (index !== -1) {
    // We found a matching TimeRange
    playableTime = buffered.end(index) - startingPoint;
  }

  // Return result
  return playableTime;
}

/**
 * Checks if the element has buffered at least the given amount of seconds or
 * if it can finish playing the video in seconds
 */
export function checkIfBufferIsLongerThan(element: HTMLMediaElement, seconds: number) {
  const bufferedDuration = getPlayableBufferDuration(element);
  const remainingDuration = element.duration - element.currentTime;

  return bufferedDuration >= Math.min(seconds, remainingDuration);
}
